<template>
  <div class="login-body">
    <div class="logo-login">
      <img src="/images/connect_logo.png" alt="SmegConnect Logo"/>
      <span class="logo-name">{{ tenant==='smeg' ? 'Professional' : 'Consumer' }}</span>
    </div>
    <form @submit.prevent="handleSubmit(!v$.$invalid)">
      <div class="field">
        <div class="p-float-label p-input-icon-right">
          <i class="pi pi-user" />
          <InputText id="username" v-model="v$.username.$model" :class="{ 'p-invalid': v$.username.$invalid && submitted }"
             :placeholder="$t('login_placeholder_username')" :aria-label="$t('login_placeholder_username')" />
        </div>
        <span v-if="v$.username.required && submitted"> <!-- <span v-if="v$.username.$error && submitted"> -->
          <span id="username-error">
            <small v-if="(v$.username.$invalid && submitted) || v$.username.$pending.$response" class="p-error">
              {{ $t('login_label_emptyUsername') }}
            </small>
          </span>
        </span>
      </div>
      <div class="field">
        <div class="p-float-label">
          <Password id="password" v-model="v$.password.$model" :class="{ 'p-invalid': v$.password.$invalid && submitted }"
            :placeholder="$t('login_placeholder_password')" :aria-label="$t('login_placeholder_password')" :feedback="false" toggleMask>
          </Password>
        </div>
        <!-- <small
          v-if="
            (v$.password.required && submitted) || v$.password.$pending.$response  //(v$.password.$error && submitted) || v$.password.$pending.$response
          "
          class="p-error"
          >Password empty</small
        > -->
        <small v-if="(v$.password.$invalid && submitted) || v$.password.$pending.$response" class="p-error">
          {{ $t('login_label_emptyPassword') }}
        </small>
      </div>
      <div class="field-checkbox">
        <!-- <Checkbox
          id="accept"
          name="accept"
          value="Accept"
          v-model="v$.accept.$model"
          :class="{ 'p-invalid': v$.accept.$invalid && submitted }"
        /> -->
        
        <!-- <Checkbox id="accept" v-model="accept" value="accept" /> -->

        <!-- <label
          for="accept"
          :class="{ 'p-error': v$.accept.$invalid && submitted }"
          >Remember me</label
        > -->
        <!-- <label for="accept">Remember me</label> -->
      </div>
      <Button :disabled="toggleButton" type="submit" label="Login" class="mt-2" />
      <small v-if="error" class="p-error">{{ this.error }}</small>

      <div class="switch-tenant">
        {{ $t('login_label_switchProfile') }} 
        <router-link :to="tenant==='smeg' ? 'login' : 'login-professional'" class="">
          {{ tenant==='smeg' ? 'CONSUMER' : 'PROFESSIONAL' }}
        </router-link>
      </div>
    </form>
  </div>
</template>

<script>
import { useVuelidate } from "@vuelidate/core";
import { required } from "@vuelidate/validators";
import LoginService from "../service/LoginService";
import { mapActions, mapState } from "pinia";
import { useLoginStore } from "../stores/login.js";
import { useApplianceStore } from "../stores/appliance.js";
import { useBreadcrumbStore } from "../stores/breadcrumb.js";
import { useCampaignsStore } from "../stores/campaign.js";
import { useAnalyticsStore } from "../stores/charts.js";
import { useGroupsStore } from "../stores/group.js";
import { useReportStore } from "../stores/reports.js";
import { useTagsStore } from "../stores/tags.js";
import { useUsersStore } from "../stores/user.js";
// import Checkbox from 'primevue/checkbox';
import { loadMessages } from '../i18n'
export default {
  setup() {
    return { v$: useVuelidate() };
  },
  props: {
    tenant: String
  },
  data() {
    return {
      submitted: false,
      username: "",
      password: null,
      accept: false,
      error: null,
      toggleButton: false
    };
  },
  created() {
    this.loginService = new LoginService();
    // this.setTenant({ label: "default", key: "" });
    useLoginStore().$reset();
    this.changeTenant();
    //Reset stores
    useApplianceStore().$reset();
    useBreadcrumbStore().$reset();
    useCampaignsStore().$reset();
    useAnalyticsStore().$reset();
    useGroupsStore().$reset();
    useReportStore().$reset();
    useTagsStore().$reset();
    useUsersStore().$reset();


    // console.log("!!! TENANT !!!",this.tenant);
  },
  watch: {
    tenant: 'changeTenant'
  },
  async mounted() {
    
  },
  validations() {
    return {
      username: {
        required,
      },
      password: {
        required,
      },
      accept: {
        required,
      },
    };
  },
  methods: {
    ...mapActions(useLoginStore, ["setTenant", "setLoginParameters", "fetchPersonalInfo", "setCredentialParameters", "setAbacConfig", "addRoutesMenu"]),
    ...mapState(useLoginStore, ["getAbacConfig", "getTenant"]),
    handleSubmit(isFormValid) {
      this.toggleButton = true;
      this.submitted = true;

      if (!isFormValid) {
        this.toggleButton = false;
        return;
      }

      this.login();
    },
    async changeTenant() {
      // console.log("tenant changed", this.tenant);
      let tenant_obj = {label: this.tenant, key: this.tenant};
      this.setTenant(tenant_obj);
      const messages = await loadMessages(this.$i18n.locale, this.tenant);
      this.$i18n.setLocaleMessage(this.$i18n.locale, messages);
    },
    login: async function () {
      this.error = null;
      this.loading = true;
      await this.loginService
        .login(this.username, this.password)
        .then(async (data) => {
          if (data.status && data.status === 200) {
            // await this.loginService.loginIOcentro().then((data) => {
            //   this.setIoCentroTokens(
            //     data.accessToken,
            //     data.refreshToken,
            //     data.tenantAdminUserCode
            //   );
            // });
            if (data.data.ChallengeName && data.data.ChallengeName === "NEW_PASSWORD_REQUIRED") {
              this.setCredentialParameters(
                this.username,
                this.password,
                data.data.Session
              );
              this.loading = false;
              this.toggleButton = false;
              this.$router.push({
                name: "first-access",
              });

            } else {
              this.setLoginParameters(
                // data.data.AuthenticationResult.AccessToken,
                // data.data.AuthenticationResult.ExpiresIn,
                // data.data.AuthenticationResult.RefreshToken,
                // data.data.AuthenticationResult.IdToken
                data.data.accessToken,
                86400,
                data.data.refreshToken,
                data.data.accessToken,
                data.data.iotUserCode
              );
              await this.fetchPersonalInfo();
              this.loading = false;
              await this.setAbacConfig();
              // let tenant_obj = {label: (this.getAbacConfig()).tenants[0], key: (this.getAbacConfig()).tenants[0]};
              // await this.setTenant(tenant_obj);
              this.addRoutesMenu(this.$router);

              this.toggleButton = false;
              if (this.getAbacConfig()?.role_def?.device) {
                this.$router.push({
                  name: "Appliances",
                });
              } else {
                  this.$router.push({
                  name: "Users",
                });
              }
            }

          } else {
            this.loading = false;
            this.error = data.response.data.message;
            this.toggleButton = false;
          }
        })
        .catch((error) => {
          console.error("ERROR", error);
          this.loading = false;
          this.error = error.response?.data?.detail ?? error.message;
          this.toggleButton = false;
        });
    },
  },
};
</script>

<style lang="css">

.switch-tenant {
  color: white;
  position: absolute;
  right: 0;
  bottom: 0;
  margin: 1rem;
}

.switch-tenant a {
  color: white;
}

</style>